import es from 'date-fns/locale/es';
import { AUTH_ROLES, AUTH_TOKEN, COOKIE_AUTH_DETAILS, ROLES } from 'globalconfig/constants/keys';
import { IS_ADMIN } from 'globalconfig/constants/validation';
import { getCookie } from 'globalservices/cookie';
import { getLocalStorage, setLocalStorage } from 'globalservices/storage';
import lodash from 'lodash';
import moment from 'moment';
import { registerLocale } from 'react-datepicker';
import { DOMAIN_CONFIG } from './constants';
import esKey from './esKey';
import { enterpriseFeaturesKeyMapperHandler } from './featureMapHandler';

const { Parser } = require('json2csv');
const serviceProvider = window.$environment?.SERVICE_PROVIDER;
const appLayout = window.$environment.CURRENT_LAYOUT;

export const getAuthDetails = (isParsingNeeded = true) => {
  const auth = getCookie(COOKIE_AUTH_DETAILS);
  if (isParsingNeeded) {
    if (auth && Object.keys(auth).length) {
      return (
        {
          ...parseJwt(auth[AUTH_TOKEN]),
          userId: auth?.userId,
          ...(auth?.producerCode ? { producerCode: auth?.producerCode } : {}),
          ...(auth?.parentProducerCode ? { parentProducerCode: auth?.parentProducerCode } : {}),
          ...(auth?.allowReseller ? { allowReseller: auth?.allowReseller } : {}),
          ...(auth?.superAdminPrivilege && window.$environment?.SERVICE_PROVIDER === 'gs'
            ? { superAdmin: auth?.superAdminPrivilege }
            : {}),
          ...(auth?.settings ? { settings: auth?.settings } : {}),
          showCreditCardPopUp: auth?.showCreditCardPopUp ? auth?.showCreditCardPopUp : false,
          amountToBePaid: auth?.amountToBePaid || null,
          autoPayment: auth?.autoPayment || false,
          enterpriseFeatureDto: enterpriseFeaturesKeyMapperHandler(auth)?.enterpriseFeatureDto,
          subscriptions: enterpriseFeaturesKeyMapperHandler(auth)?.subscriptions,
          adminSuspended: auth?.adminSuspended,
          showBanner: auth?.settings?.SHOW_GIG_SURVEY_POPUP === false ? false : true,
          showUpgradePopup: auth?.settings?.SHOW_UPGRADE_POPUP === false ? false : true,
        } || null
      );
    } else {
      return auth
        ? {
          ...auth,
          enterpriseFeatureDto: enterpriseFeaturesKeyMapperHandler(auth)?.enterpriseFeatureDto,
          subscriptions: enterpriseFeaturesKeyMapperHandler(auth)?.subscriptions,
        }
        : null;
    }
  } else {
    return auth
      ? {
        ...auth,
        enterpriseFeatureDto: enterpriseFeaturesKeyMapperHandler(auth)?.enterpriseFeatureDto,
        subscriptions: enterpriseFeaturesKeyMapperHandler(auth)?.subscriptions,
      }
      : null;
  }
};

export const hasRestrictedRole = (permittedRoles) => {
  const auth = getAuthDetails();
  if (permittedRoles?.length && auth?.auth) {
    if (!IS_ADMIN && permittedRoles.includes('ADMIN') && (auth.auth.includes('OWNER') || auth.auth.includes('FLMANAGER'))) {
      return false;
    } else {
      const result = permittedRoles?.some((r) => {
        return auth.auth.includes(r);
      });
      return result;
    }
  } else {
    return true;
  }
};

export const hasEnabledFeature = (module) => {
  if (IS_ADMIN) return true;

  const auth = getAuthDetails();
  if (auth) {
    const { enterpriseFeatureDto } = auth;
    return (
      (enterpriseFeatureDto?.[module] !== undefined && enterpriseFeatureDto?.[module]) ||
      enterpriseFeatureDto?.[module] === undefined
    );
  } else {
    return true;
  }
};

export const isdvirOnly = () => {
  const auth = getAuthDetails(false);
  if (auth && auth.enterpriseFeatureDto && auth.enterpriseFeatureDto?.dvirOnlyEnabled) return true;
  if (window.$environment.SERVICE_PROVIDER === DOMAIN_CONFIG['DVIRONLY']) return true;
  return false;
};

export const isInsuracePortalUser = () => {
  const auth = getAuthDetails(false);
  if (auth && auth.roles.some((role) => [ROLES.UNDER_WRITER, ROLES.LOSS_CONTROL, ROLES.CLAIM_ADJUSTER].includes(role)))
    return true;
  return false;
};

export const removeListItem = (source, field, value) => {
  for (let i = 0; i < source.length; i++) {
    const item = source[i];
    if (item[field] === value) {
      source.splice(i, 1);
    }
  }
  return source;
};

export const getCompanyId = () => {
  return getCookie('companyId');
};

export const getCompanyTimeZone = () => {
  const auth = getCookie(COOKIE_AUTH_DETAILS);
  return auth.timeZone;
};

export const getDotNumber = () => {
  return getCookie('dotNumber');
};

export const getCameraUserId = () => {
  return getCookie('cameraPortalUserId');
};

export const hasEnabledSettings = (module) => {
  const auth = getCookie(COOKIE_AUTH_DETAILS);
  if (auth) {
    const { settings } = auth;
    return settings?.[module] || false;
  } else return false;
};

export const getLastQuaters = (lastQuater) => {
  let today = new Date();
  let quaters = {};
  let currentMonth = new Date().getMonth();
  if (currentMonth > 8)
    quaters = {
      ['Q1' + ' - ' + today.getFullYear()]: [
        moment(new Date(today.getFullYear(), 0)).startOf('month'),
        moment(new Date(today.getFullYear(), 2)).endOf('month'),
      ],
      ['Q2' + ' - ' + today.getFullYear()]: [
        moment(new Date(today.getFullYear(), 3)).startOf('month'),
        moment(new Date(today.getFullYear(), 5)).endOf('month'),
      ],
      ['Q3' + ' - ' + today.getFullYear()]: [
        moment(new Date(today.getFullYear(), 6)).startOf('month'),
        moment(new Date(today.getFullYear(), 8)).endOf('month'),
      ],
      ['Q4' + ' - ' + today.getFullYear()]: [
        moment(new Date(today.getFullYear(), 9)).startOf('month'),
        moment(new Date(today.getFullYear(), 11)).endOf('month'),
      ],
    };
  else if (currentMonth > 5) {
    quaters = {
      ['Q4' + ' - ' + (today.getFullYear() - 1)]: [
        moment(new Date(today.getFullYear() - 1, 9)).startOf('month'),
        moment(new Date(today.getFullYear() - 1, 11)).endOf('month'),
      ],
      ['Q1' + ' - ' + today.getFullYear()]: [
        moment(new Date(today.getFullYear(), 0)).startOf('month'),
        moment(new Date(today.getFullYear(), 2)).endOf('month'),
      ],
      ['Q2' + ' - ' + today.getFullYear()]: [
        moment(new Date(today.getFullYear(), 3)).startOf('month'),
        moment(new Date(today.getFullYear(), 5)).endOf('month'),
      ],
      ['Q3' + ' - ' + today.getFullYear()]: [
        moment(new Date(today.getFullYear(), 6)).startOf('month'),
        moment(new Date(today.getFullYear(), 8)).endOf('month'),
      ],
    };
  } else if (currentMonth > 2) {
    quaters = {
      ['Q3' + ' - ' + (today.getFullYear() - 1)]: [
        moment(new Date(today.getFullYear() - 1, 6)).startOf('month'),
        moment(new Date(today.getFullYear() - 1, 8)).endOf('month'),
      ],
      ['Q4' + ' - ' + (today.getFullYear() - 1)]: [
        moment(new Date(today.getFullYear() - 1, 9)).startOf('month'),
        moment(new Date(today.getFullYear() - 1, 11)).endOf('month'),
      ],
      ['Q1' + ' - ' + today.getFullYear()]: [
        moment(new Date(today.getFullYear(), 0)).startOf('month'),
        moment(new Date(today.getFullYear(), 2)).endOf('month'),
      ],
      ['Q2' + ' - ' + today.getFullYear()]: [
        moment(new Date(today.getFullYear(), 3)).startOf('month'),
        moment(new Date(today.getFullYear(), 5)).endOf('month'),
      ],
    };
  } else {
    quaters = {
      ['Q2' + ' - ' + (today.getFullYear() - 1)]: [
        moment(new Date(today.getFullYear() - 1, 3)).startOf('month'),
        moment(new Date(today.getFullYear() - 1, 5)).endOf('month'),
      ],
      ['Q3' + ' - ' + (today.getFullYear() - 1)]: [
        moment(new Date(today.getFullYear() - 1, 6)).startOf('month'),
        moment(new Date(today.getFullYear() - 1, 8)).endOf('month'),
      ],
      ['Q4' + ' - ' + (today.getFullYear() - 1)]: [
        moment(new Date(today.getFullYear() - 1, 9)).startOf('month'),
        moment(new Date(today.getFullYear() - 1, 11)).endOf('month'),
      ],
      ['Q1' + ' - ' + today.getFullYear()]: [
        moment(new Date(today.getFullYear(), 0)).startOf('month'),
        moment(new Date(today.getFullYear(), 2)).endOf('month'),
      ],
    };
  }
  if (lastQuater) return Object.values(quaters)[3];
  else return quaters;
};

export const getDateLocale = () => {
  if (getLocalStorage('Language') && getLocalStorage('Language') == 'es') {
    registerLocale('es', es);
    return 'es';
  } else return false;
};

export const getFilterLocaleValues = (values, i18n) => {
  if (getLocalStorage('Language') && getLocalStorage('Language') == 'es' && values) {
    let returnValues = JSON.parse(JSON.stringify(values));
    returnValues.forEach((ele) => {
      if (ele && ele.label) ele.label = i18n.t(ele.label.trim());
    });
    return returnValues;
  } else return values;
};

export const getEsKey = (value) => {
  if (getLocalStorage('Language') && getLocalStorage('Language') == 'es') {
    let returnVal = '';
    Object.keys(esKey).forEach((ele) => {
      if (esKey[ele] == value) returnVal = ele;
    });
    returnVal = returnVal ? returnVal : value;
    return returnVal;
  } else return value;
};

export const hasValue = (source, key, value) => {
  if (source) {
    for (let index = 0; index < source.length; index++) {
      const element = source[index];

      if (value && element[key] === value) {
        return element;
      }
    }
    return null;
  } else {
    return null;
  }
};

export const getLanguageCode = (code) => {
  return code === 'en' ? 'es' : 'en';
};

export const setLanguageFromStorage = (i18n, defaultLang) => {
  const currentLanguage = getLocalStorage('Language') || defaultLang;
  if (currentLanguage !== i18n.language) {
    setLocalStorage('Language', currentLanguage);
    i18n.changeLanguage(currentLanguage);
  }
  return currentLanguage;
};

export const setLanguage = (i18n, code) => {
  const newCode = code !== undefined ? code.toLowerCase() : getLanguageCode(i18n.language);
  if (newCode !== i18n.language) {
    setLocalStorage('Language', newCode);
    i18n.changeLanguage(newCode).then(() => {
      const auth = getCookie(COOKIE_AUTH_DETAILS);
      if (auth?.showCreditCardPopUp) {
        return;
      }
      window.location.reload();
    });
  }
  return newCode;
};

export const showLanguageCode = (defaultLang, keepTextAsLang) => {
  const currentLanguage = getLocalStorage('Language') || defaultLang;
  return keepTextAsLang ? currentLanguage : getLanguageCode(currentLanguage);
};

export const getStyle = (style, theme, defaultValue) => {
  const styleValue = style || '';
  const themeValue = theme || '';
  return styleValue ? styleValue : themeValue ? themeValue : defaultValue;
};

export const parseJwt = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((c) => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join('')
  );

  return JSON.parse(jsonPayload);
};

export const normalizeString = (str) => {
  return str ? str.toString().replace(/\s+/g, '').toLowerCase() : '';
};

export const filterList = (source, key, value) => {
  let result = [];
  const normalizedValue = normalizeString(value);

  if (typeof key === 'string') {
    if (key.includes('.')) {
      let keyObj = key.split('.');
      result = lodash.filter(source, (item) =>
        item[keyObj[0]]
          ? normalizeString(item[keyObj[0]][keyObj[1]]).includes(normalizedValue)
          : ''
      );
    } else {
      result = lodash.filter(source, (item) => {

        return item[key]
          ? normalizeString(item[key]).includes(normalizedValue)
          : '';
      });
    }
  } else {
    result = lodash.filter(source, (item, index) => {
      let temp = key.filter((keys) => {
        return item[keys]
          ? normalizeString(item[keys]).includes(normalizedValue)
          : '';
      });
      return temp.length ? true : false;
    });
  }
  return result;
};

export const filterWithDateRange = (source, dateFrom, dateTo) => {
  const from = dateFrom !== null && dateFrom !== undefined ? moment(dateFrom).format('X') : moment('01/01/2000').format('X');
  const to = dateTo !== null && dateTo !== undefined ? moment(dateTo).format('X') : moment(new Date()).format('X');
  const result = lodash.filter(source, (item) => {
    let d = moment(item.date.split(' ')[0]).format('X');
    return parseInt(from) <= parseInt(d) && parseInt(to) >= parseInt(d);
  });
  return result;
};

export const exportData = (fields, data, filename) => {
  const field = fields;
  const json2csvParser = new Parser({ field });
  const csv = json2csvParser.parse(data);
  var element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(csv));
  element.setAttribute('download', filename + '.csv');
  element.style.display = 'none';
  if (typeof element.download != 'undefined') {
    //browser has support - process the download
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  } else {
    //browser does not support - alert the user
    alert('This functionality is not supported by the current browser, recommend trying with Google Chrome instead.');
  }
};

export const getQueryStringKeys = (string, key) => {
  const urlParams = new URLSearchParams(string);
  return urlParams.get(key);
};

/** Returns the currently selected language code (e.g. 'en', 'es', 'fr'). Defaults to 'en'. */
export const getCurrentLanguage = () => {
  const fromUi = getLocalStorage('Language');
  const fromLegacy = typeof window !== 'undefined' && window.$environment?.SERVICE_PROVIDER
    ? localStorage.getItem(window.$environment.SERVICE_PROVIDER + 'Language')
    : null;
  const raw = fromUi || fromLegacy;
  return (raw && typeof raw === 'string' ? raw.toLowerCase() : null) || 'en';
};

/** True when the currently selected language is Spanish. */
export const isEs = () => getCurrentLanguage() === 'es';

export const getLogsInfoDisplay = (i18n, name, date) => {
  name = i18n.t(name);
  return name
    ? isEs()
      ? `${i18n.t('common.logbookDetails', { name })} ${date}`
      : `${name}'s ${i18n.t('common.logbookDetails')} ${date}`
    : 'Daily Log';
};

export const getListOfSelectedField = (list, field, callback) => {
  const result = list?.length ? list.map((item) => item[field]) : [];
  return result;
};

export const deleteJsonArrayItemByField = (source, key, value) => {
  return source.filter((option) => option[key] !== value);
};

export const objectArrayFromDiffFields = (list, field, value, callback) => {
  return list?.length
    ? list.map((item) => {
      if (callback) return callback(item, field, value);
      else
        return {
          label: item[value],
          value: item[field],
        };
    })
    : [];
};

export const objectArrayFromSameField = (list) => {
  return list?.length
    ? list.map((item) => {
      return {
        label: item,
        value: item,
      };
    })
    : [];
};

export const objectArrayFromMultipleFields = (list, value, field, callback) => {
  return list?.length
    ? list.map((item) => {
      if (callback) return callback(item, value, field);
      else
        return {
          label: `${item[field[0]]} ${item[field[1]]}`,
          value: item[value],
        };
    })
    : [];
};

export const isValidObject = (source) => {
  const isNotUndefined = typeof source !== 'undefined';
  const isNotNull = !(typeof source !== 'object' || !source);
  return isNotUndefined && isNotNull;
};

export const getUniqueList = (source) => {
  return source.filter((v, i) => source.indexOf(v) === i);
};

export const getNewObject = (parentProps, newProps) => {
  return Object.keys(parentProps)
    .filter((key) => newProps.includes(key))
    .reduce((final, current) => ({ ...final, [current]: parentProps[current] }), {});
};

export const findAndDeleteParentInJson = (source, key, value) => {
  const resultArray = source.map((element) => {
    return element[key] !== value ? element : null;
  });

  for (let index = 0; index < resultArray.length; index++) {
    const element = resultArray[index];
    if (!element) {
      resultArray.splice(index, 1);
      index--;
    }
  }

  return resultArray;
};

export const getLanguage = (code) => {
  if (code) {
    return code === 'English' ? 'EN' : 'ES';
  } else return 'EN';
};

export const getLocaleFile = (file) => {
  try {
    return require(`globalconfig/locales/${file}/${serviceProvider}/${appLayout}`);
  } catch (error) {
    return require(`globalconfig/locales/${file}/${serviceProvider}`);
  }
};

// export const loadComponetStyle = (ParentStyled, url) => {
//   try {
//     const style = require(`globalcomponents/${url}/${window?.$environment?.CURRENT_LAYOUT}`)?.default;
//     return { ...ParentStyled, ...style };
//   } catch (error) {
//     return ParentStyled;
//   }
// };

export const hasRestrictedCommmonRole = (permittedRoles, excludedRoles) => {
  // get the user's authentication details
  const auth = getAuthDetails();

  // check if permittedRoles is not empty and if auth is defined and has a role array
  if (permittedRoles.length && auth?.auth) {
    // if the length of the user's role array matches the length of the permittedRoles array
    if (auth.auth.length === permittedRoles.length) {
      // check if every role in the user's role array is included in the permittedRoles array
      return auth.auth.every((role) => permittedRoles.includes(role));
    }
    // if the length of the user's role array is one more than the length of the permittedRoles array
    else if (auth.auth.length === permittedRoles.length + 1) {
      // create a copy of the user's role array
      const authRoles = [...auth.auth];
      // if excludedRoles is an array and not empty
      if (Array.isArray(excludedRoles) && excludedRoles.length > 0) {
        // loop through the excludedRoles array
        excludedRoles.forEach((role) => {
          // find the index of the role in the authRoles array
          const excludedRoleIndex = authRoles.indexOf(role);
          // if the role is found, remove it from the authRoles array
          if (excludedRoleIndex >= 0) {
            authRoles.splice(excludedRoleIndex, 1);
          }
        });
      }
      // check if every role in the updated authRoles array is included in the permittedRoles array
      return authRoles.every((role) => permittedRoles.includes(role));
    }
  }
  // return false if the user does not have any common role with the permittedRoles
  return false;
};

export const isResellerAdmin = () => {
  return hasRestrictedRole([AUTH_ROLES['RESELLER_ADMIN']]);
};

export const isSupportUser = () => {
  return hasRestrictedRole([AUTH_ROLES.SUPPORT]) ? true : false;
};

// const getMediaImagePath = (file) => {
//   try {
//     const image = require(`globalassets/media/${process.env.REACT_APP_BUILD}/${serviceProvider}/${file}`);
//     return image;
//   } catch (error) {
//     const image = require(`globalassets/media/${process.env.REACT_APP_BUILD}/${serviceProvider}/${appLayout}/${file}`);
//     return image;
//   }
// };

// export const getImagePath = (file) => {
//   if (file) {
//     try {
//       const image = getMediaImagePath(file);
//       return image;
//     } catch (error) {
//       const image = require(`globalassets/media/common/${file}`);
//       return image;
//     }
//   }
// };

export const generateDropdownOptions = (list, displayField, valueField) => {
  return list?.length
    ? list.map((item) => {
      return {
        value: item[valueField] || '',
        label: item[displayField] || item[valueField] || '',
      };
    })
    : [];
};

export const findListItemFm = (roles, currentRole, dependencies, enterpriseFeatureDto, config = null) => {
  const isDvirOnlyFeatureEnabled = isdvirOnly();
  const auth = getAuthDetails();
  if (roles?.length && currentRole) {
    const result = roles.some((r) => {
      return currentRole.includes(r);
    });
    let isValidModule = true;
    if (dependencies?.length) {
      for (let index = 0; index < dependencies.length; index++) {
        const element = dependencies[index];

        if (
          element === 'paymentInformation' &&
          currentRole.includes('ADMIN') &&
          !currentRole.includes('FLMANAGER') &&
          !currentRole.includes('OWNER')
        ) {
          isValidModule = false;
        } else if (element === 'udBulkEditEnabled') {
          if (
            (enterpriseFeatureDto?.[element] !== undefined && enterpriseFeatureDto?.[element] === false) ||
            enterpriseFeatureDto?.[element] === undefined
          ) {
            isValidModule = true;
          } else {
            isValidModule = false;
          }
        } else if (element === 'dvirSpecific' && !isDvirOnlyFeatureEnabled) {
          isValidModule = false;
        } else if (element === 'dvirSpecific' && isDvirOnlyFeatureEnabled) {
          isValidModule = true;
        } else if (element === 'dvirOnly' && isDvirOnlyFeatureEnabled) {
          isValidModule = true;
        } else if (element !== 'dvirOnly' && isDvirOnlyFeatureEnabled) {
          isValidModule = false;
        } else if (element === 'dvirOnly' && !isDvirOnlyFeatureEnabled) {
          isValidModule = true;
        } else if (
          !auth?.showUpgradePopup &&
          enterpriseFeatureDto?.[element] !== undefined &&
          enterpriseFeatureDto?.[element] === false
        ) {
          isValidModule = false;
        } else if (
          auth?.showUpgradePopup &&
          auth.enterpriseFeatureDto?.[config?.module] !== undefined &&
          auth.enterpriseFeatureDto?.[config?.module] === false
        ) {
          isValidModule = true;
        } else if (
          (enterpriseFeatureDto?.[element] !== undefined && enterpriseFeatureDto?.[element]) ||
          enterpriseFeatureDto?.[element] === undefined
        ) {
          isValidModule = true;
        } else {
          if (
            element === 'reportsEnabled' &&
            window.$environment.SERVICE_PROVIDER === 'spireon' &&
            enterpriseFeatureDto.spireonReportsEnabled
          ) {
            isValidModule = true;
          } else {
            isValidModule = false;
          }
        }
      }
    }

    return result && isValidModule;
  } else if (roles?.length === 0) {
    return true;
  } else {
    return null;
  }
};

export const findListItemManagement = (roles, currentRole) => {
  if (roles?.length && currentRole) {
    const result = roles.some((r) => {
      return currentRole.includes(r) && currentRole;
    });
    let isValidModule = true;
    return result && isValidModule;
  } else if (roles?.length === 0) {
    return true;
  } else {
    return null;
  }
};

export const findListItem = (roles, currentRole, dependencies, enterpriseFeatureDto, config = null) => {
  return IS_ADMIN
    ? findListItemManagement(roles, currentRole)
    : findListItemFm(roles, currentRole, dependencies, enterpriseFeatureDto, (config = null));
};

export function isUdEdit() {
    const currentUrl = window.location.href;
    return /\/edit\/0\//.test(currentUrl);
  }


export function stripHtml(html) {
  if (typeof window !== 'undefined') {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.textContent || div.innerText || '';
  }
  return html;
}

/**
 * Compare two arrays of objects and find differences, only checking specified keys.
 * @param {Array} originalArray - Original array of objects.
 * @param {Array} newArray - New array of objects.
 * @param {Array} checkKeys - List of keys to check during comparison (only these keys will be compared).
 * @returns {{ differences: Array, changedNewObjects: Array, changedOriginalObjects: Array }}
 */
export function compareObjectArrays(originalArray, newArray, checkKeys = []) {
  const differences = [];
  const changedNewObjects = [];
  const changedOriginalObjects = [];

  originalArray.forEach((orig, index) => {
    const updated = newArray[index];
    if (!updated) return;

    const diff = {};

    // Only check keys that are in the checkKeys array
    checkKeys.forEach((key) => {
      if (Object.prototype.hasOwnProperty.call(orig, key) || Object.prototype.hasOwnProperty.call(updated, key)) {
        if (orig[key] !== updated[key]) {
          diff[key] = {
            original: orig[key],
            new: updated[key]
          };
        }
      }
    });

    if (Object.keys(diff).length > 0) {
      differences.push({ index, differences: diff });
      changedNewObjects.push(updated);

      // Clone orig to avoid mutating the original array
      const origClone = { ...orig };
      if (Object.prototype.hasOwnProperty.call(origClone, 'editedEntryId') && origClone.editedEntryId === "") {
        origClone.editedEntryId = null;
      }
      changedOriginalObjects.push(origClone);
    }
  });

  return { differences, changedNewObjects, changedOriginalObjects };
}

